import React from 'react'

import {
  Code,
  Title,
  Description,
  Container,
  Button,
  WatermarkContainer,
  WatermarkText,
} from './style'

const HttpError = ({ code, title, message, link, history }) => (
  <div>
    <WatermarkContainer>
      <WatermarkText>{code}</WatermarkText>
    </WatermarkContainer>
    <Container>
      <Code>{code}</Code>
      <Title>{title}</Title>

      <Description>{message}</Description>
      {link && (
        <Button
          className="back-button"
          onClickHandler={() => history.push(link)}
        >
          Go back to Homepage
        </Button>
      )}
    </Container>
  </div>
)

HttpError.defaultProps = {
  title: 'Http Error',
  code: 500,
  message: 'An expected error to your requests',
}

export { HttpError }



// WEBPACK FOOTER //
// ./src/Components/Page/HttpError/index.js